import http from 'services/http';

// AI-driven portal retrieval runs (OLIO-2605). The web app starts a run, hands its id
// to the browser extension, and the extension drives the AI turns — the recorded action
// sequence becomes a PortalScript. See services/portalExtension for the hand-off.

export interface PortalAiRunGoal {
  outputs: string[];
  instructions?: string;
}

export interface CreatePortalAiRunInput {
  sourceSystem: string;
  goal: PortalAiRunGoal;
  availableParams: Record<string, string>;
}

export async function createPortalAiRun(input: CreatePortalAiRunInput) {
  return http.post<{ id: string; status: string }>('portal_ai_runs', input).then((res) => res.data);
}
